import { CLEARALLCART_MODAL_SHOW,CLEARALLCART_MODAL_HIDE } from "../Actions/ClearAllCartPopUp.action";
const defaultState = {  
  showClearAllcartPop: false
};
export const clearallcartpopup = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
     case CLEARALLCART_MODAL_SHOW:
        return {
          ...state,
          ...action.payload,
          showClearAllcartPop: true
        };
      case CLEARALLCART_MODAL_HIDE:
        return {
          ...state,
          ...action.payload,
          showClearAllcartPop: false
        };      
    default:
      return state;
  }
};
